var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9251 11.4483C8.9251 11.0672 8.98733 10.725 9.11177 10.4217C9.23622 10.1183 9.49288 9.85388 9.88177 9.62832C9.99844 9.55832 10.1423 9.47665 10.3134 9.38332C10.4845 9.28999 10.6518 9.1811 10.8151 9.05665C10.9784 8.93221 11.1145 8.78832 11.2234 8.62499C11.3401 8.46165 11.3984 8.2711 11.3984 8.05332C11.3984 7.73443 11.2857 7.48943 11.0601 7.31832C10.8345 7.13943 10.5779 7.04999 10.2901 7.04999C9.94788 7.04999 9.66399 7.15499 9.43844 7.36499C9.21288 7.56721 9.03788 7.77332 8.91344 7.98332L7.89844 7.28332C8.10066 6.80888 8.42344 6.43943 8.86677 6.17499C9.31788 5.91054 9.80788 5.77832 10.3368 5.77832C10.7334 5.77832 11.1145 5.85999 11.4801 6.02332C11.8534 6.17888 12.1607 6.42776 12.4018 6.76999C12.6429 7.10443 12.7634 7.53999 12.7634 8.07665C12.7634 8.57443 12.6507 8.9711 12.4251 9.26665C12.1995 9.55443 11.904 9.8111 11.5384 10.0367C11.3284 10.1611 11.1223 10.2817 10.9201 10.3983C10.7179 10.515 10.5468 10.655 10.4068 10.8183C10.2745 10.9739 10.2084 11.1839 10.2084 11.4483H8.9251ZM8.94844 14.1667V12.5567H10.2434V14.1667H8.94844Z",
    fill: "#202635"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7.08333,
    stroke: "#202635",
    strokeWidth: 0.833333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2430d813.svg";
export { ForwardRef as ReactComponent };